<template>
    <!-- 我的收藏 -->
    <div class="collection-mask"> 
        <div class="personal-center-title">收藏文章</div>
        <contentList :list="contentList"/>  
        <pagination v-show="contentList.length>=1" @no-change-pagination="noChangePagination" :pages="page.count"/>
    </div>
</template>

<script>
    import contentList from "@/components/common/contentList/index.vue";
    import pagination from "@/components/common/pagination/index.vue";
    import { followList } from "@/api/lxc";
    import { getToken } from "../../../../static/js/util.js"
    export default {
        name: 'Collection',
        data () {
            return {
                contentList:[],
                page:{
                    page:1,
                    pageSize:10,
                    count:0
                }
            }
        },
        components:{
            contentList,
            pagination
        },
        methods:{
            noChangePagination(res){
                console.log(res)
                this.page.page=res.data.page;
                this.page.pageSize=res.data.pageSize;
                this.followListFn()
            },
            async followListFn(){
                this.contentList=[];
                try { 
                    const data=await followList({
                        unique_code:getToken("unique_code"),
                        page:this.page.page,
                        pageSize:this.page.pageSize
                    })
                    console.log(data)
                    this.contentList=data.list;
                    this.page.count=data.count;
                }catch(err){
                    
                }
            }
        },
        mounted(){ 
            this.followListFn()
        }
    }
</script>

<style scoped lang="less">
.collection-mask{
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    padding-bottom: 40px;
    h3{ 
        padding:0 0px 16px 0px;
        p{
            padding:0 40px;
            height:60px;
            line-height: 60px;
            font-size:18px;
            font-weight:600;
            color:rgba(51,51,51,1);
            // border-bottom: 1px solid rgba(0,0,0,0.1);
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/page/personalCenter/user/collection.vue